(function () {
    'use strict';

    angular
        .module('uwAgenda.settings.administration')
        .directive('licenceItem', LicenceItemFn);

    LicenceItemFn.$inject = [];

    function LicenceItemFn() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/settings/administration/modules/licences/templates/licence-item.template.html',
            controller: 'LicenceItemController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                licence: '='
            }
        };
        return directive;

    }

})();